export function detachOutgoingFrames(): void {
  document.querySelectorAll('iframe').forEach((frame) => {
    frame.remove();
  });
}

export function installOutgoingFrameDetach(): void {
  if (typeof window === 'undefined') return;
  window.addEventListener('pagehide', detachOutgoingFrames);
}
